import React from "react";
import { Col, Form, Button } from "react-bootstrap";
import Select from "react-select";
import { saveWebhook } from "../../../../api";
import Modal from "react-modal";
import { webhookType } from "../../../../constants";
import Secret from "./Secret";

class Webhook extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {
                url: props.webhook?.url || "",
                method: props.webhook?.call_type || "",
                progressions: props.webhook?.progression_to_update
                    ? JSON.parse(props.webhook?.progression_to_update)
                    : [],
                headerKeys: props.webhookKeyVals?.headerKey || {},
                headerValues: props.webhookKeyVals?.headerValue || {},
                bodyKeys: props.webhookKeyVals?.bodyKey || {},
                bodyValues: props.webhookKeyVals?.bodyValue || {},
                type: props.webhook?.type || props.type,
                organisationId: props.organizationId,
            },
            errors: {},
            webhook: props.webhook ? props.webhook : {},
            isSuccess: false,
            modalOpen: false,
            spinner: false,
        };
    }

    addHeaderOption = () => {
        let index = Object.keys(this.state.form.headerKeys).length;
        let key = this.state.form.headerKeys;
        key["headerKey" + index] = "";
        let value = this.state.form.headerValues;
        value["headerValue" + index] = "";
        this.setState({
            form: {
                ...this.state.form,
                headerKeys: key,
                headerValues: value,
            },
        });
    };

    removeHeader = (index) => {
        let headerKeys = this.state.form.headerKeys;
        delete headerKeys["headerKey" + index];
        let headerValues = this.state.form.headerValues;
        delete headerValues["headerValue" + index];
        this.setState({
            form: {
                ...this.state.form,
                headerKeys: headerKeys,
                headerValues: headerValues,
            },
        });
    };

    addBodyOption = () => {
        let index = Object.keys(this.state.form.bodyKeys).length;
        let key = this.state.form.bodyKeys;
        key["bodyKey" + index] = "";
        let value = this.state.form.bodyValues;
        value["bodyValue" + index] = "";
        this.setState({
            form: {
                ...this.state.form,
                bodyKeys: key,
                bodyValues: value,
            },
        });
    };

    removeBody = (index) => {
        let bodyKeys = this.state.form.bodyKeys;
        delete bodyKeys["bodyKey" + index];
        let bodyValues = this.state.form.bodyValues;
        delete bodyValues["bodyValue" + index];
        this.setState({
            form: {
                ...this.state.form,
                bodyKeys: bodyKeys,
                bodyValues: bodyValues,
            },
        });
    };

    handleChange = (e, type = null) => {
        e.persist();
        let name = e.target.name;
        let value = e.target.value;
        if (type == "headerKey") {
            let key = this.state.form.headerKeys;
            key[name] = value;
            this.setState({
                form: {
                    ...this.state.form,
                    headerKeys: key,
                },
            });
        } else if (type == "headerValue") {
            let key = this.state.form.headerValues;
            key[name] = value;
            this.setState({
                form: {
                    ...this.state.form,
                    headerValues: key,
                },
            });
        } else if (type == "bodyKey") {
            let key = this.state.form.bodyKeys;
            key[name] = value;
            this.setState({
                form: {
                    ...this.state.form,
                    bodyKeys: key,
                },
            });
        } else if (type == "bodyValue") {
            let key = this.state.form.bodyValues;
            key[name] = value;
            this.setState({
                form: {
                    ...this.state.form,
                    bodyValues: key,
                },
            });
        } else {
            let form = this.state.form;
            form[name] = value;
            this.setState({
                form: form,
            });
        }
    };

    selecChange = (e) => {
        var progs = e.map((item) => {
            return item.value;
        });
        this.setState({
            form: {
                ...this.state.form,
                progressions: progs,
            },
        });
    };

    Submit = (e) => {
        e.preventDefault();
        this.setState({
            spinner: true,
            modalOpen: true,
        });
        saveWebhook(this.state.form)
            .then((res) => {
                this.setState({
                    errors: {},
                    spinner: false,
                    isSuccess: true,
                    modalOpen: true,
                });

                setTimeout(() => {
                    this.setState({
                        isSuccess: false,
                        modalOpen: false,
                    });
                }, 2000);
            })
            .catch((err) => {
                // Not every failure carries a Laravel validation bag. A 403
                // from the permission check answers {message}, and a non-JSON
                // error (proxy/Cloudflare) is reshaped to {error, info} by the
                // api.js response interceptor — neither has `.data.errors`.
                // Defaulting to {} matters because render() dereferences
                // errors.url / errors.method / errors.progressions directly, so
                // an undefined here threw during render and blanked the whole
                // Edit Organization page rather than showing the error.
                const errors = err?.data?.errors ?? {};
                const message = err?.data?.message ?? err?.error;

                this.setState({
                    errors:
                        Object.keys(errors).length === 0 && message
                            ? { url: message }
                            : errors,
                    spinner: false,
                    modalOpen: false,
                });
            });
    };

    handleCloseModal = () => {
        this.setState({
            modalOpen: false,
        });
    };

    render() {
        let { errors, form, isSuccess, totalCount } = this.state;
        const { organizationId, type } = this.props;
        let options = Object.entries(this.props.progressions).map(
            ([key, value]) => {
                return { label: value, value: key };
            },
        );
        let defaultValue = [];
        Object.entries(this.props.progressions).forEach(([key, value]) => {
            if (form.progressions.includes(key)) {
                defaultValue.push({
                    label: value,
                    value: key,
                });
            }
        });
        return (
            <div>
                <Form onSubmit={(e) => this.Submit(e)}>
                    <Form.Row>
                        <Form.Group
                            as={Col}
                            xs={2}
                            lg={2}
                            className="px-3 modal-pd rev-tier"
                        >
                            <Form.Label>URL</Form.Label>
                        </Form.Group>
                        <Col xs={10} lg={10}>
                            <Form.Group
                                as={Col}
                                xs={11}
                                lg={11}
                                className="px-3 modal-pd rev-tier"
                            >
                                <Form.Control
                                    type="text"
                                    name="url"
                                    value={form.url}
                                    onChange={(e) => this.handleChange(e)}
                                    placeholder="URL"
                                />
                            </Form.Group>
                            {errors.url !== undefined && (
                                <div>
                                    <Form.Group
                                        as={Col}
                                        xs={2}
                                        lg={2}
                                    ></Form.Group>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        as={Col}
                                        xs={10}
                                        lg={10}
                                    >
                                        {errors.url}
                                    </Form.Control.Feedback>
                                </div>
                            )}
                        </Col>
                    </Form.Row>
                    <Form.Row>
                        <Secret organizationId={organizationId} type={type} />
                    </Form.Row>
                    <Form.Row>
                        <Form.Group
                            as={Col}
                            xs={2}
                            lg={2}
                            className="px-3 modal-pd rev-tier"
                        >
                            <Form.Label>Method</Form.Label>
                        </Form.Group>
                        <Col xs={10} lg={10}>
                            <Form.Group
                                as={Col}
                                xs={3}
                                lg={3}
                                className="px-3 modal-pd rev-tier method-option"
                            >
                                <Form.Check
                                    label="GET"
                                    type="radio"
                                    name="method"
                                    id="get"
                                    onChange={(e) => this.handleChange(e)}
                                    checked={"GET" == form.method}
                                    value={"GET"}
                                />
                            </Form.Group>
                            <Form.Group
                                as={Col}
                                xs={3}
                                lg={3}
                                className="px-3 modal-pd rev-tier method-option"
                            >
                                <Form.Check
                                    label="POST"
                                    type="radio"
                                    name="method"
                                    id="post"
                                    onChange={(e) => this.handleChange(e)}
                                    checked={"POST" == form.method}
                                    value={"POST"}
                                />
                            </Form.Group>
                            <Form.Group
                                as={Col}
                                xs={4}
                                lg={4}
                                className="px-3 modal-pd rev-tier method-option"
                            >
                                <Form.Check
                                    label="PUT"
                                    type="radio"
                                    name="method"
                                    id="put"
                                    onChange={(e) => this.handleChange(e)}
                                    checked={"PUT" == form.method}
                                    value={"PUT"}
                                />
                            </Form.Group>

                            {errors.method !== undefined && (
                                <div>
                                    <Form.Group
                                        as={Col}
                                        xs={2}
                                        lg={2}
                                    ></Form.Group>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        as={Col}
                                        xs={10}
                                        lg={10}
                                    >
                                        {errors.method}
                                    </Form.Control.Feedback>
                                </div>
                            )}
                        </Col>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group
                            as={Col}
                            xs={2}
                            lg={2}
                            className="px-3 modal-pd rev-tier"
                        >
                            <Form.Label>Headers</Form.Label>
                        </Form.Group>
                        <Col xs={10} lg={10}>
                            {Object.keys(form.headerKeys).length > 0 &&
                                Object.entries(form.headerKeys).map(
                                    (item, index) => (
                                        <div key={index}>
                                            <Form.Group
                                                as={Col}
                                                xs={5}
                                                lg={5}
                                                className="px-3 modal-pd rev-tier"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    name={item[0]}
                                                    value={item[1]}
                                                    onChange={(e) =>
                                                        this.handleChange(
                                                            e,
                                                            "headerKey",
                                                        )
                                                    }
                                                />
                                            </Form.Group>

                                            <Form.Group
                                                as={Col}
                                                xs={6}
                                                lg={6}
                                                className="px-3 modal-pd rev-tier"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    name={
                                                        "headerValue" +
                                                        item[0].split("y")[1]
                                                    }
                                                    value={
                                                        form.headerValues[
                                                            "headerValue" +
                                                                item[0].split(
                                                                    "y",
                                                                )[1]
                                                        ]
                                                    }
                                                    onChange={(e) =>
                                                        this.handleChange(
                                                            e,
                                                            "headerValue",
                                                        )
                                                    }
                                                />
                                            </Form.Group>
                                            {index == 0 && (
                                                <Form.Group
                                                    as={Col}
                                                    xs={1}
                                                    lg={1}
                                                    className="px-3 modal-pd rev-tier"
                                                >
                                                    <Button
                                                        variant="primary"
                                                        type="button"
                                                        onClick={(e) =>
                                                            this.addHeaderOption()
                                                        }
                                                    >
                                                        Add
                                                    </Button>
                                                </Form.Group>
                                            )}
                                            {index != 0 && (
                                                <Form.Group
                                                    as={Col}
                                                    xs={1}
                                                    lg={1}
                                                    className="px-3 modal-pd rev-tier"
                                                >
                                                    <Button
                                                        variant="danger"
                                                        type="button"
                                                        onClick={(e) =>
                                                            this.removeHeader(
                                                                item[0].split(
                                                                    "y",
                                                                )[1],
                                                            )
                                                        }
                                                    >
                                                        X
                                                    </Button>
                                                </Form.Group>
                                            )}
                                        </div>
                                    ),
                                )}

                            {Object.keys(form.headerKeys).length == 0 && (
                                <div>
                                    <Form.Group
                                        as={Col}
                                        xs={5}
                                        lg={5}
                                        className="px-3 modal-pd rev-tier"
                                    >
                                        <Form.Control
                                            type="text"
                                            name={"headerKey0"}
                                            value={
                                                form.headerValues["headerKey0"]
                                            }
                                            onChange={(e) =>
                                                this.handleChange(
                                                    e,
                                                    "headerKey",
                                                )
                                            }
                                        />
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={6}
                                        lg={6}
                                        className="px-3 modal-pd rev-tier"
                                    >
                                        <Form.Control
                                            type="text"
                                            name={"headerValue0"}
                                            value={
                                                form.headerValues[
                                                    "headerValue0"
                                                ]
                                            }
                                            onChange={(e) =>
                                                this.handleChange(
                                                    e,
                                                    "headerValue",
                                                )
                                            }
                                        />
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={1}
                                        lg={1}
                                        className="px-3 modal-pd rev-tier"
                                    >
                                        <Button
                                            variant="primary"
                                            type="button"
                                            onClick={(e) =>
                                                this.addHeaderOption()
                                            }
                                        >
                                            Add
                                        </Button>
                                    </Form.Group>
                                </div>
                            )}
                        </Col>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group
                            as={Col}
                            xs={2}
                            lg={2}
                            className="px-3 modal-pd rev-tier"
                        >
                            <Form.Label>Body</Form.Label>
                        </Form.Group>
                        <Col xs={10} lg={10}>
                            {Object.keys(form.bodyKeys).length > 0 &&
                                Object.entries(form.bodyKeys).map(
                                    (item, index) => (
                                        <div key={index}>
                                            <Form.Group
                                                as={Col}
                                                xs={5}
                                                lg={5}
                                                className="px-3 modal-pd rev-tier"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    name={item[0]}
                                                    value={item[1]}
                                                    onChange={(e) =>
                                                        this.handleChange(
                                                            e,
                                                            "bodyKey",
                                                        )
                                                    }
                                                />
                                            </Form.Group>

                                            <Form.Group
                                                as={Col}
                                                xs={6}
                                                lg={6}
                                                className="px-3 modal-pd rev-tier"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    name={
                                                        "bodyValue" +
                                                        item[0].split("ey")[1]
                                                    }
                                                    value={
                                                        form.bodyValues[
                                                            "bodyValue" +
                                                                item[0].split(
                                                                    "ey",
                                                                )[1]
                                                        ]
                                                    }
                                                    onChange={(e) =>
                                                        this.handleChange(
                                                            e,
                                                            "bodyValue",
                                                        )
                                                    }
                                                />
                                            </Form.Group>
                                            {index == 0 && (
                                                <Form.Group
                                                    as={Col}
                                                    xs={1}
                                                    lg={1}
                                                    className="px-3 modal-pd rev-tier"
                                                >
                                                    <Button
                                                        variant="primary"
                                                        type="button"
                                                        onClick={(e) =>
                                                            this.addBodyOption()
                                                        }
                                                    >
                                                        Add
                                                    </Button>
                                                </Form.Group>
                                            )}
                                            {index != 0 && (
                                                <Form.Group
                                                    as={Col}
                                                    xs={1}
                                                    lg={1}
                                                    className="px-3 modal-pd rev-tier"
                                                >
                                                    <Button
                                                        variant="danger"
                                                        type="button"
                                                        onClick={(e) =>
                                                            this.removeBody(
                                                                item[0].split(
                                                                    "ey",
                                                                )[1],
                                                            )
                                                        }
                                                    >
                                                        X
                                                    </Button>
                                                </Form.Group>
                                            )}
                                        </div>
                                    ),
                                )}

                            {Object.keys(form.bodyKeys).length == 0 && (
                                <div>
                                    <Form.Group
                                        as={Col}
                                        xs={5}
                                        lg={5}
                                        className="px-3 modal-pd rev-tier"
                                    >
                                        <Form.Control
                                            type="text"
                                            name={"bodyKey0"}
                                            onChange={(e) =>
                                                this.handleChange(e, "bodyKey")
                                            }
                                        />
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={6}
                                        lg={6}
                                        className="px-3 modal-pd rev-tier"
                                    >
                                        <Form.Control
                                            type="text"
                                            name={"bodyValue0"}
                                            onChange={(e) =>
                                                this.handleChange(
                                                    e,
                                                    "bodyValue",
                                                )
                                            }
                                        />
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={1}
                                        lg={1}
                                        className="px-3 modal-pd rev-tier"
                                    >
                                        <Button
                                            variant="primary"
                                            type="button"
                                            onClick={(e) =>
                                                this.addBodyOption()
                                            }
                                        >
                                            Add
                                        </Button>
                                    </Form.Group>
                                </div>
                            )}
                        </Col>
                    </Form.Row>
                    {type == webhookType.PAYMENT_CLOUD ? (
                        <Form.Row>
                            <Form.Group
                                as={Col}
                                xs={2}
                                lg={2}
                                className="px-3 modal-pd rev-tier"
                            >
                                <Form.Label>Progressions</Form.Label>
                            </Form.Group>
                            <Col xs={10} lg={10}>
                                <Form.Group
                                    as={Col}
                                    xs={11}
                                    lg={11}
                                    className="px-3 modal-pd rev-tier"
                                >
                                    <Select
                                        options={options}
                                        name="progressions[]"
                                        defaultValue={defaultValue}
                                        onChange={(e) => this.selecChange(e)}
                                        isMulti={true}
                                    />
                                </Form.Group>
                                {errors.progressions !== undefined && (
                                    <div>
                                        <Form.Group
                                            as={Col}
                                            xs={2}
                                            lg={2}
                                        ></Form.Group>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            as={Col}
                                            xs={10}
                                            lg={10}
                                        >
                                            {errors.progressions}
                                        </Form.Control.Feedback>
                                    </div>
                                )}
                            </Col>
                        </Form.Row>
                    ) : (
                        <></>
                    )}

                    <div class="container">
                        <div class="row">
                            <div class="col text-center">
                                <Button variant="primary" type="submit">
                                    Submit
                                </Button>
                            </div>
                        </div>
                    </div>
                </Form>
                <Modal isOpen={this.state.modalOpen}>
                    <div className="modal-header pd8">
                        <h4 className="text-left d-inlineBlock webbook-heading">
                            Webhook
                        </h4>
                        <span
                            onClick={() => this.handleCloseModal()}
                            className="modal-cancel"
                        >
                            <img src="/images/cancel.svg" />
                        </span>
                    </div>

                    <div className="modal-body pd8">
                        {this.state.spinner && <p className="loader"></p>}
                        {isSuccess && (
                            <div className="alert alert alert-success show">
                                Webhook saved.
                            </div>
                        )}
                    </div>
                </Modal>
            </div>
        );
    }
}

export default Webhook;
